<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  value: {
    type: Number,
    required: false,
    default: 0,
  },
  unit: {
    type: String,
    required: false,
    default: ''
  }
});

const batteryLines = computed(() => Math.round(props.value / 100 * 6));
const noBattery = computed(() => !props.unit);
</script>

<template>
  <div class="h-5 w-[37px] flex items-center">
    <div
      class="border border-1 w-full h-full flex p-[1px]"
      :class="noBattery && 'border-border'"
    >
      <div
        v-if="props.unit !== 'V' && !noBattery"
        class="flex gap-[1px]"
      >
        <div
          v-for="index in batteryLines"
          :key="index"
          class="bg-foreground h-full w-1"
        />
      </div>
      <div
        v-else
        class="text-[10px] text-center flex items-center justify-center w-full"
      >
        <div v-if="noBattery">
          <div class="h-[1px] w-2 bg-muted-foreground" />
        </div>
        <div v-else>
          {{ props.value.toFixed(1) }}{{ props.unit }}
        </div>
      </div>
    </div>
    <div
      class="bg-foreground w-1 h-2"
    />
  </div>
</template>
